// extracted by mini-css-extract-plugin
module.exports = {"Scholar":"_1O2I7ZDY3cALfNs0UREeGa"};